// DOM contract shared with pagination, which grows the fill to the page bottom.
export const PRINTOUT_PAGE_BREAK_FILL_CLASS = "printout-page-break-fill";

export const PRINTOUT_PAGE_BREAK_RULE_CLASS = "printout-page-break-rule";

export const PRINTOUT_PAGE_BREAK_LABEL_CLASS = "printout-page-break-label";
